const config = {
  pagination: false,
  rowSelection: false,
  fieldControl: false,
  columns: [
    {
      title: '合同类型',
      dataIndex: 'typeName',
      width: 200,
    },
    {
      title: '合同号',
      dataIndex: 'contractNo',
      width: 300,
    },
    {
      title: '金额（元）',
      dataIndex: 'contractAmount',
      width: 140,
    },
    {
      title: '报价人',
      dataIndex: 'createdByName',
      width: 100,
      name: 'createdByName',
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      width: 160,
      itemType:'dateTime',
      name: 'createdTime',
    },
    {
      title: '合同状态',
      dataIndex: 'flowStateName',
      width: 100,
    },
    {
      title: '操作',
      width: 200,
      render: 'operation',
      fixed: 'right',
    },
  ],
  search: [

  ]
  // footer: [
  //   {
  //     label: '合同变更历史',
  //     type: 'primary',
  //     events: ['onClick:handleContractHistoryFn'],
  //   },
  //   {
  //     label: '刷新',
  //     type: 'primary',
  //     events: ['onClick:reload'],
  //   }
  // ],
}

export default config